var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-apollo-hooks/~/lodash/_getPrototype.js
// module id = 438
// module chunks = 178331994103267 231608221292675